export default __webpack_public_path__ + "static/media/try_again.34ec238e.svg";